module.exports = {
  currency: {
    MATIC: "matic",
    HBAR: "hbar",
    NEAR: "near",
    SIKI: "siki"
  },

  act: {
    GO_HOME: "goHome",
    OPEN_DRAWER: "openDrawer",
    CLOSE_DRAWER: "closeDrawer",
    TOGGLE_DRAWER: "toggleDrawer",
    OPEN_FULL_SCREEN: "openFullScreen",
    CLOSE_FULL_SCREEN: "closeFullScreen",
    HIDE_STREAM: "hideStream",
  }
}
